export const QUICKSTART_PANEL_ID = 'jpd-quickstart';
export const QUICKSTART_PANEL_WIDTH = 365;

export const QuickstartPanel = () => null; // quickstart panel content will be added later
